export enum AppNotificationType {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
  DEFAULT = "default",
  LOADING = "loading",
}
